import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faSave } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import baseURL from '../../url';
import { useData } from '../../DataContext';

const DIAS = [
    { dia: 1, nombre: 'Lunes' },
    { dia: 2, nombre: 'Martes' },
    { dia: 3, nombre: 'Miércoles' },
    { dia: 4, nombre: 'Jueves' },
    { dia: 5, nombre: 'Viernes' },
    { dia: 6, nombre: 'Sábado' },
    { dia: 7, nombre: 'Domingo' },
];

export default function HorariosData() {
    const { horarios, cargarHorarios } = useData();
    const [filas, setFilas] = useState([]);
    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        const mapa = {};
        (horarios || []).forEach(h => { mapa[h.dia] = h; });
        setFilas(DIAS.map(d => {
            const h = mapa[d.dia] || {};
            return {
                dia: d.dia,
                nombre: d.nombre,
                cerrado: h.cerrado ? true : false,
                apertura: h.apertura ? h.apertura.slice(0, 5) : '08:00',
                cierre: h.cierre ? h.cierre.slice(0, 5) : '22:00',
            };
        }));
    }, [horarios]);

    const setFila = (dia, campo, valor) => {
        setFilas(prev => prev.map(f => f.dia === dia ? { ...f, [campo]: valor } : f));
    };

    const guardar = async () => {
        setEnviando(true);
        try {
            const payload = {
                horarios: filas.map(f => ({
                    dia: f.dia,
                    cerrado: f.cerrado,
                    apertura: f.cerrado ? null : f.apertura,
                    cierre: f.cerrado ? null : f.cierre,
                })),
            };
            const res = await fetch(`${baseURL}/horariosPut.php`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (data.mensaje) { toast.success(data.mensaje); cargarHorarios(); }
            else { toast.error(data.error || 'Error al guardar'); }
        } catch (e) {
            toast.error('Error de conexión');
        }
        setEnviando(false);
    };

    return (
        <div style={{ background: '#fff', border: '1px solid #e9ecef', borderRadius: '12px', padding: '18px', marginBottom: '16px' }}>
            <h4 style={{ margin: '0 0 12px', fontSize: '15px', color: '#212529' }}>
                <FontAwesomeIcon icon={faClock} style={{ color: 'var(--color1)', marginRight: '8px' }} /> Horarios del local
            </h4>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {filas.map(f => (
                    <div key={f.dia} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', padding: '8px 10px', border: '1px solid #f0f0f0', borderRadius: '8px', background: f.cerrado ? '#f1f3f5' : '#fff' }}>
                        <span style={{ width: '90px', fontWeight: 600, color: '#495057' }}>{f.nombre}</span>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', color: '#495057' }}>
                            <input
                                type="checkbox"
                                checked={f.cerrado}
                                onChange={(e) => setFila(f.dia, 'cerrado', e.target.checked)}
                            />
                            Cerrado
                        </label>
                        <input
                            type="time"
                            value={f.apertura}
                            disabled={f.cerrado}
                            onChange={(e) => setFila(f.dia, 'apertura', e.target.value)}
                            style={{ padding: '6px 8px', border: '1px solid #dee2e6', borderRadius: '6px', fontSize: '13px' }}
                        />
                        <span style={{ color: '#6c757d' }}>a</span>
                        <input
                            type="time"
                            value={f.cierre}
                            disabled={f.cerrado}
                            onChange={(e) => setFila(f.dia, 'cierre', e.target.value)}
                            style={{ padding: '6px 8px', border: '1px solid #dee2e6', borderRadius: '6px', fontSize: '13px' }}
                        />
                    </div>
                ))}
            </div>

            <button
                onClick={guardar}
                disabled={enviando}
                style={{ marginTop: '12px', padding: '10px 18px', background: 'var(--color1)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
            >
                <FontAwesomeIcon icon={faSave} /> {enviando ? 'Guardando...' : 'Guardar horarios'}
            </button>
        </div>
    );
}
